import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _EntryForUBLInvoice, _PayrollImportedDataCatalog, _UBLItemGenerate, _Updateschema } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../../../core/services/Singleton";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../../theme/Component/Modal";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../../../theme/Component/BasicTable";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { MonthEditorbyconst } from "../../../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { AccountantYear } from "../../../../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { ImportedDataConstantsList } from "../../../../../Talentohumano/ParametrosTalentoHumano/FortnightImport/ImportedDataConstantsList";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { SelectDocumentStateConstants } from "../../../../../contabilidad/CatalogoDocumentosUBL/Selectores/SelectDocumentStateConstants";
import { UBLInventoryEntryDocument } from "./UBLInventoryEntryDocument";
import { SelectAccountantConceptCatalogForSupplierInvoice } from "../SelectAccountantConceptCatalogForSupplierInvoice";
import { SelectorDocumentFactory } from "../../../../../contabilidad/bodegaDocumentos/SelectorDocumentFactory";
import { DocumentStorageEditor } from "../../../../../contabilidad/bodegaDocumentos/DocumentStorageEditor";
import { ManageUBLInvoiceItems } from "./ManageUBLInvoiceItems";
import { _DocumentFactory, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { SelectStoreEditor } from "../SelectStore.editor";
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { CreateUBLInvoiceItems } from "../CreateUBLInvoice/CreateUBLInvoiveItem";
import { GoodTypesConstantsEditor } from "../CreateUBLInvoice/GoodTypesConstants.editor";
import { SelectProductEditor } from "../../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { UBLFixedDocFactory } from "./UBLFixedDocFactory";
import { MakeUBLInvoice } from "../MakeUBLInvoice";



export const UBLItemInvoiceGenerate = () => {

    const ubl = useDataBean(_UBLItemGenerate);
    const createfixed = useDataBean(_EntryForUBLInvoice);
    const updateschema = useDataBean(_Updateschema);
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [form, setForm] = useState<any>({
        IDDocument: null,
        DocumentDate: null,
        DocType: null
    });
    const [docFormato, setDocFormato] = useState<any>([]);
    const [docs, setDocs] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [msgList, setMsgList] = useState<any>([]);
    const [formato, setFormato] = useState<any>([]);
    const [regexStr, setregexStr] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [Year, setYear] = useState<number>(_single.getCurrenYear())
    const [idAccountantConcept, setidAccountantConcept] = useState<number>(null)
    const [State, setState] = useState<number>(null)
    const [Acc, setAcc] = useState<number>(null)
    const [Month, setMonth] = useState<number>(null)
    const [modalB, setModalB] = useState<any>({ view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalfactura, setModalfactura] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalpdf, setModalpdf] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalgenerate, setModalgenerate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const firstRun = useRef(true)

    useEffect(() => {
        if (firstRun.current) {
            firstRun.current = false;
            return;
        }

        // Cuando el modal se cierra
        if (!modalfactura.view) {
            getLista();
        }
    }, [modalfactura.view]);

    useEffect(() => {
        getLista();
    }, [paginador.page])

    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);

    const getLista = () => {

        ubl.instance.getUblInvoiceCatalogForStore(Acc, Year, Month, State, form.DocType, form.IDDocument, form.DocumentDate, idAccountantConcept, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }
    const verDocumentos = () => {

        if (ubl.bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(ubl.bean.IDDocument, null, ubl.bean.EAFDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const create = () => {
        setModalfactura({ ...modalfactura, "view": true });
    }
    const onInvoiceCreatedOrImported = () => {
        getLista();
    }
    const deleteItem = () => {
        ubl.deleteItemVoid(ubl.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const createFixedAssetEntryForUBLInvoice = () => {
        if (!createfixed.bean.RecordDate) {
            toast.warning("Debe seleccionar una Fecha de Registro Contable.");
            return;
        }
        if (!createfixed.bean.IDAccountantConcept) {
            toast.warning("Debe seleccionar un Concepto de Ingreso.");
            return;
        }
        if (!createfixed.bean.IDStore) {
            toast.warning("Debe seleccionar un Almacen.");
            return;
        }
        createfixed.instance.createFixedAssetEntryForUBLInvoice(ubl.bean.IDUBLInvoice, ubl.bean.IssueDate, createfixed.bean.IDAccountantConcept, createfixed.bean.RecordDate, createfixed.bean.IDStore, createfixed.bean.DefaultType, createfixed.bean.IDProduct, createfixed.bean.IDAdquisitionContract, createfixed.bean.AdquisitionContractDate, createfixed.bean.UserOtherDocumentFactory, createfixed.bean.DocumentClassFactory, _single.getAccountID()).then(
            (resp: any) => {

                setDocFormato(resp.DocumentURL);
                setModalgenerate({ ...modalgenerate, "view": false })
                setModalpdf({ ...modalpdf, "view": true })
                console.log(resp)
                toast.success("Se realizo la Acción");
                setMsgList(resp.MsgList);

                // ✅ Mostrar cada mensaje del backend en un toast
                resp.MsgList?.forEach((msg: string) => {
                    toast.info(msg);
                });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const updateTaxSchemaValuesForUBLInvoice = () => {

        updateschema.instance.updateTaxSchemaValuesForUBLInvoice(ubl.bean.IDUBLInvoice, ubl.bean.IssueDate).then(
            (resp: any) => {

                toast.success("Se realizo la Acción");
                getLista()
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const editaItem = () => {


    }
    const finalizar = (modalview: boolean) => {
        //console.log(modalview)
        if (modalview) {
            setModal({ ...modal, "view": false });
            getLista();
        }
    }
    const head = [
        { title: 'ID Factura', property: 'IDUBLInvoice', visible: true, mask: MASK_NUMBER },
        { title: 'No Factura', property: 'InvoiceID', visible: true },
        { title: 'Tipo UBL', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Nit - Proveedor', property: 'AccountSupplierName', visible: true },
        { title: 'Líneas Factura', property: 'LineCountNumeric', visible: true },
        { title: 'Valor Total', property: 'TotalInvoiceAmount', visible: true, mask: MASK_MONEY },
        // { title: 'Impuestos', property: 'TaxAmount', visible: true },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
        { title: 'Entrada Almacén', property: 'EAFMnemonic', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Consecutivo Entrada', property: 'EAFConsecutive', visible: true },
        { title: 'Fecha Entrada', property: 'EAFDate', visible: true },
        { title: 'Fecha Procesamiento', property: 'Since', visible: true },
        { title: 'Estado Factura', property: 'DocumentStateName', visible: true },
        { title: 'Tipo Factura', property: 'SourceTypeName', visible: true },
        // { title: 'Tipo Factura', property: 'DocumentTypeName', visible: true },
        { title: 'Estado EAF', property: 'EAFDocumentStateName', visible: true },
        { title: 'Estado Salidas', property: 'OutputCostStateName', visible: true },
        { title: 'Documento Soporte', property: 'IsDocumentSupport', visible: true },
        { title: 'Concepto de Ingreso', property: 'AccountantConceptName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Puente Ingreso Bienes', property: 'CreditAccountantIDName', visible: true },
        { title: 'Pertenece a Proceso', property: 'ProcessTypeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar Factura de Proveedor', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Clasificar Activos y Productos', icono: 'ri-stack-line', visible: true, evento: () => { setModal({ ...modal, "view": true, "name": `Clasificar Activos y Productos de la Factura ${ubl.bean.IDUblInvoice}` }) } },
            { titulo: 'ver Items de la Factura', icono: 'ri-list-ordered', visible: true, evento: () => { setModalB({ ...modalB, "view": true, "name": `Items de la Factura` }) } },
            { titulo: 'Actualizar Cálculo de Impuestos', icono: 'ri-creative-commons-sa-fill', visible: true, evento: () => { updateTaxSchemaValuesForUBLInvoice() } },
            { titulo: 'Generar Entrada de Almacén', icono: 'ri-archive-drawer-line', visible: true, evento: () => { setModalgenerate({ ...modalgenerate, "view": true }) } },
            { titulo: 'Ver Documento de Entrada de Almacén', icono: 'ri-profile-fill', visible: true, evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Generar Entrada de Activos Fijos">
            <div className="row">
                <div className="col-md-6">
                    <AccountEditor label="Proveedor" idAccount={Acc} onChange={(e) => { setAcc(e.IDAccount) }}></AccountEditor>
                </div>
                <div className="col-md-6">
                    <SelectDocumentStateConstants idSelect={State} onChange={(e) => { setState(e) }} />
                </div>
                <div className="col-md-6">
                    <UBLInventoryEntryDocument idSelector={form.DocType} onChange={(e) => { setForm({ ...form, DocType: e }) }} />
                </div>
                <div className="col-md-6">
                    <DocumentStorageEditor label="Selector de Documentos" mNemonic={form.DocType} onChange={(e) => { setForm({ ...form, IDDocument: e.IDDocument, DocumentDate: e.DocumentDate }) }} />
                    {/* <SelectorDocumentFactory label="Selector de Documentos" filterDocument={Statedoc} id={form.IDDocument} onChange={(e) => { setForm({ ...form, "IDDocument": e.IDDocument, 'documentDate': e.DocumentDate }) }} /> */}
                </div>
                <div className="col-md-6">
                    <SelectAccountantConceptCatalogForSupplierInvoice idSelector={idAccountantConcept} onChange={(e) => { setidAccountantConcept(e) }} />
                </div>
                <div className="col-md-6">
                    <AccountantYear idSelector={Year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-6">
                    <MonthEditorbyconst idSelector={Month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-database-2-line" eventClick={getLista}> Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={ubl.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal}>
                        <ManageUBLInvoiceItems _idUBLInvoice={ubl.bean.IDUBLInvoice} _onChange={(e) => { finalizar(e); }} _issueDate={ubl.bean.IssueDate} _invoice={ubl.bean} />
                    </Modal>
                    <Modal modal={modalB} updateModal={setModalB} >
                        <CreateUBLInvoiceItems idUBLInvoice={ubl.bean.IDUBLInvoice} issueDate={ubl.bean.IssueDate} _onChange={() => { getLista(); }} />
                    </Modal>
                    <Modal modal={modalfactura} updateModal={setModalfactura}>

                        <MakeUBLInvoice
                            _onChange={onInvoiceCreatedOrImported}
                            menuOptions={["supplier", "import"]}
                            importTypeDocument="Supplier"
                        />

                    </Modal>
                    <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docs}
                                    IDDocument={ubl.bean.IDDocument}
                                    Since={ubl.bean.EAFDate}
                                />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalgenerate} updateModal={setModalgenerate} eventModal={createFixedAssetEntryForUBLInvoice}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <SelectAccountantConceptCatalogForSupplierInvoice idSelector={createfixed.bean.IDAccountantConcept} onChange={(e: any) => { createfixed.setBean({ ...createfixed.bean, 'IDAccountantConcept': e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <InputDate notDate label="Fecha de Registro Contable" name="Date" value={createfixed.bean.RecordDate} setDate={(e) => { createfixed.setBean({ ...createfixed.bean, "RecordDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <SelectStoreEditor label='Almacén/Bodega' idSelector={createfixed.bean.IDStore} onChange={(e: any) => { createfixed.setBean({ ...createfixed.bean, "IDStore": e.IDStore }) }} />
                                </div>
                                <div className="col-md-6">
                                    <GoodTypesConstantsEditor label='Tipo por defecto' idSelector={createfixed.bean.DefaultType} onChange={(e: any) => { createfixed.setBean({ ...createfixed.bean, "DefaultType": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <SelectProductEditor label="Producto por defecto" value={createfixed.bean.IDProduct} onChange={(e) => { createfixed.setBean({ ...createfixed.bean, "IDProduct": e.IDProduct }) }} />
                                </div>
                                <div className="col-md-12">
                                    <SelectAdquisitionContract label="Contrato de Adquisiciones" idSelector={createfixed.bean.IDAdquisitionContract} onChange={(e) => { createfixed.setBean({ ...createfixed.bean, 'IDAdquisitionContract': e.IDAdquisitionContract, 'AdquisitionContractDate': e.AdquisitionContractDate }) }} />
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Definir Fábrica de Documentos" estado={createfixed.bean.UserOtherDocumentFactory} eventChange={(e) => { createfixed.setBean({ ...createfixed.bean, "UserOtherDocumentFactory": e }) }} />
                                </div>
                                {createfixed.bean.UserOtherDocumentFactory && <>
                                    <div className="col-md-6">
                                        <UBLFixedDocFactory idSelector={createfixed.bean.DocumentClassFactory} onChange={(e: any) => { createfixed.setBean({ ...createfixed.bean, "DocumentClassFactory": e }) }} />
                                    </div>
                                </>}
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalpdf} updateModal={setModalpdf}>
                        <>
                            <div className="row">

                                <div className="col-md-12">
                                    {/* {formato?.DocumentURL?.length > 0 && (
                                        <div className="row">
                                            <div className="col-md-12 mt-3">
                                                <label>Descarga en el Siguiente Link:*</label>
                                            </div>

                                            <div className="col-md-6 mt-3">
                                                <a
                                                    href={formato.DocumentURL[0].DataBeanProperties.URLLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <strong>
                                                        📄 {formato.DocumentURL[0].DataBeanProperties.Filename}
                                                    </strong>
                                                </a>
                                            </div>
                                        </div>
                                    )} */}
                                    <DocumentViewer
                                        list={docFormato}
                                    />
                                </div>
                            </div>

                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {ubl.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}
